module.exports = __webpack_public_path__ + "static/media/image_9.b1dfd3ac.jpg";